import React from 'react'
import Footer from './Footer'
import Header from './Header'
import Meta from './Meta'
import EventCard from './EventCard'

const CowProtection = () => {
  return (
    

   <>
   <Meta/>
   <Header/>

  {/* blog left sidebar section */}
  <section className="blog pt-4 pb-0">
    <div className="container">
      <div className="row animate__animated wow animate__fadeInUp">
        {/* blog section */}
        <div className="col-12 col-lg-12 mt-4 mt-lg-0">
          <div className="row">
            <div className="col-12 col-lg-12 mb-4">
              <div className="row g-0">
                <div className="overflow-hidden position-relative theme-border-radius col-12">
                  <figure className="mb-0">
                    <img
                      src="https://www.iskconbangalore.org/wp-content/uploads/2015/11/a15-iskcon-goshala-1200x800.jpg"
                      className="img-fluid img-thumbnail rounded-4"
                      alt="news articles"
                    />
                  </figure>
                  <div className="tags position-absolute">
                    <a href="javascript:void(0)" className="font-small">
                      <span className="d-block">08</span>March
                    </a>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <div className="mt-4 post-wrap">
                    <h2 className="text-warning fw-bold">Cow Protection</h2>
                    <p className="post-desc">
                      Srila Prabhupada writes: The human society should
                      recognize the importance of the cow and the bull and thus
                      give all protection to these important animals.
                    </p>
                    <h3 className="text-warning fw-bold">
                      <strong>Protect Cows… Protect our Civilization</strong>
                    </h3>
                    <p className="post-desc">
                      In the Vedic tradition, cows are worshipped as mothers.
                      According to the scriptures, there are seven mothers:
                      atma-mata (one’s own mother) guroh patni (the wife of
                      one’s teacher) brahmani (the wife of a brahmana)
                      raja-patnika (the wife of the king) dhenu (the cow) dhatri
                      (the nurse) and prithvi (the Earth) are all considered
                      mothers. Just as a child feeds on the breast milk of the
                      mother, human society takes milk from the cow. The bull is
                      also considered the father of human society because just
                      as the father earns to feed the children, the bull tills
                      the earth to produce food grains. So, to kill cows means
                      to end the human civilization.
                    </p>
                    <p className="post-desc">
                      A civilized man is, therefore, expected to give all
                      protection to the bulls and cows. But, today, people are
                      becoming more and more uncivilized by neglecting such
                      instructions and they are encouraging cow killing. In Rig
                      Veda (9.46.4) it is said: gobhih prinita matsaram: one who
                      is desirous of killing the cow is in the grossest
                      ignorance. Instead of killing the cow and eating its
                      flesh, civilized men must subsist on various milk and
                      agricultural products.
                    </p>
                    <h3 className="text-warning fw-bold">Pancha Gavya</h3>
                    <p>In the Srimad Bhagavatam it is said:</p>
                    <p className="post-desc">
                      gavah panca pavitrani: the cows deliver five products and
                      all of them are pure and uncontaminated. The five products
                      received from the cow are milk, ghee, yogurt, cow dung and
                      urine. These five products, called pancha-gavya, are
                      required in all ritualistic ceremonies performed according
                      to the Vedic instructions.
                    </p>
                    <p className="post-desc">
                      Cow’s milk is considered the most miraculous food which
                      helps in developing the finer tissues of the brain that
                      helps in understanding the higher purposes of life. It
                      helps one understand the intricacies of transcendental
                      knowledge. Milk can be transformed into yogurt, curd,
                      butter, ghee and by combining the milk and milk products
                      with grains; hundreds of palatable dishes can be prepared.
                      The ghee or clarified butter is used not only for
                      preparing delicacies but also for the sacrificial
                      performances. A patient who is suffering from a disorder
                      of the bowels due to overindulgence in milk products is
                      cured by another milk product, namely curds. Even the
                      urine and stool of cows have medicinal value. Cow dung
                      contains all antiseptic properties and is considered a
                      purifying agent. Cow dung can also be dried and used as
                      fuel. The cow urine and dung are used even for bathing the
                      deities.
                    </p>
                    <EventCard/>
                    <h3 className="text-warning fw-bold">
                      Cow – The Worshipable Animal
                    </h3>
                    <p>
                      In Vedic society, the economy was based on agriculture and
                      cow protection. Sri Krishna mentions this in the
                      Bhagavad-gita:
                    </p>
                    <p className="post-desc">
                      krsi-go-raksya-vanijyam vaisya-karma svabhava-jam (Bg
                      18.44) Five thousand years ago, when Krishna was
                      personally present on this planet, there was enough milk,
                      butter and curd. When there were festivals, the cowherd
                      men would throw yogurt, milk, clarified butter and water
                      upon the bodies of one another. Everyone had sufficient
                      stock of milk and other milk-products. Sri Krishna is
                      glorified as the protector of the cows and brahminical
                      culture (go-brahmana-hitaya ca). The Brahma Samhita
                      describes Lord Krishna to be tending the surabhi cows in
                      His spiritual abode of Goloka Vrindavana, which is
                      surrounded by millions of desire-fulfilling trees. In the
                      Vedas it is mentioned that all the demigods reside in the
                      body of a cow. So Hindus worship the cow.
                    </p>
                      <h3 className="text-warning fw-bold">Goshala</h3>
                    <p className="post-desc">
                      The cows are an integral part of the temples and their
                      upkeep is one of the prime activities. In India, most of
                      the Vaishnava temples have their own Goshala. The
                      unadulterated milk supplied by these cows is used for the
                      worship of the Lord.
                    </p>
                    <p className="post-desc">
                      ISKCON Bangalore started a goshala in the year 1986, with
                      one cow named Vasundhara, and her calf Tamala. Since then,
                      over the last 30 years, the herd has increased. Currently
                      there are 25 cows, housed in a facility behind the temple
                      complex, which is kept immaculately clean by a team of
                      three trained dairymen. The cows are bathed every day and
                      during the summer they are bathed twice. They are allowed
                      to roam around freely in a corral so that they can stretch
                      their limbs and get some exercise. The milk from these
                      cows is offered to the Lord not only as it is, but also
                      used in a variety of forms to prepare delicious offerings.
                      Many visitors have commented that the cows on Hare Krishna
                      Hill are peaceful and content. As the cows age, when they
                      are unable to give milk, they are moved to ISKCON
                      Bangalore’s farm at Mahadevapura in Mandya district where
                      they peacefully spend the rest of their lives, grazing on
                      the fresh grass and the sweet hay that is readily
                      available there. The young bulls are also moved to the
                      farm. There, these energetic animals are trained to plough
                      the fields and carry loads to help in farming activities.
                    </p>
                    <p className="post-desc">
                      In Brihat Parashara Smriti (5.26-27) it is said that one
                      who feeds the cow with grass and water every day derives
                      the benefit equivalent to performing Ashwamedha Yajna.
                      Those interested in contributing towards the feeding of
                      cows CLICK HERE.
                    </p>
                    <p className="post-desc">
                      You can also sponsor the maintenance of the cows in the
                      Goshala in Bengaluru as well as the retired cows and bulls
                      at the Hare Krishna Farm at Mahadevapura.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* post content */}
            
          </div>
        </div>
        
      </div>
    </div>
  </section>

  <Footer/>
</>

   

  )
}

export default CowProtection